define('view/disclosure/disclosure.assignedToMe.list.page.vew',['require','exports','module','uikit/uikit','blockit','model/unit.model','model/disclosure.detail.model','view/disclosure/disclosure.list.document.action.buttons','handlebars','fukit','fukit'],function(require, exports, module) {
    //prettier-ignore
    var UIKit                 = require('uikit/uikit'),
        BlocKit               = require('blockit'),
        UnitModel             = require('model/unit.model'),
        DisclosureDetailModel = require('model/disclosure.detail.model'),
        DisclosureListDocumentActionButtons = require('view/disclosure/disclosure.list.document.action.buttons'),
        Handlebars            = require('handlebars'),
        ROLES                 = require('fukit').Roles,
        AuthorizationBehavior = require('fukit').AuthorizationBehavior;

    var DisclosureAssignedToMeListPageView = BlocKit.ResolveOptionsView.extend({
        resolveOptions: {
            root: {
                type: BlocKit.FullWidthLayoutView,
                pageHeader: {
                    actions: [],
                },
                contentColumn: {
                    components: [
                        {
                            type: BlocKit.SearchablePageableTableView,
                            collection: '@resources.disclosureCollection',
                            columns: [
                                {
                                    text: 'Disclosure Name',
                                    behaviors: {
                                        ResolveRouteBehavior: {
                                            route: 'disclosure:form',
                                            params: { primaryId: '@model.id' },
                                            behaviorClass: BlocKit.ResolveRouteBehavior,
                                        },
                                    },
                                    sortable: true,
                                    formatter: BlocKit.Formatter.empty(),
                                    childView: UIKit.Text,
                                    childViewOptions: {
                                        color: 'primary',
                                        underline: true,
                                        bindings: {
                                            text: 'name',
                                        },
                                        formatter: function(item) {

                                            if(item && item.length > 50) {
                                                item = item.slice(0,50) + "...";
                                            }
                                            return item;
                                        },

                                    },
                                },
                                {
                                    text: 'Disclosee',
                                    data: 'disclosureOwnerName',
                                    behaviors: {
                                        ResolveRouteBehavior: {
                                            route: 'disclosure:form',
                                            params: { primaryId: '@model.id' },
                                            behaviorClass: BlocKit.ResolveRouteBehavior,
                                        },
                                    },
                                    sortable: true,
                                },
                                {
                                    text: 'Proposal',
                                    data: 'proposalNumber',
                                    sortable: false,
                                    childView: UIKit.Text,
                                    childViewOptions: {
                                        color: 'primary',
                                        underline: true,
                                        formatter: function() {
                                            var proposalNumber = this.model.get('proposalNumber');
                                            var proposalUrl = this.model.get('proposalUrl');
                                            var html = '';

                                            if (proposalNumber && proposalUrl) {
                                                html = '<a href="' + proposalUrl + '" target="_new">' + proposalNumber + '</a>';
                                            }

                                            return new Handlebars.SafeString(html);
                                        }
                                    },
                                },
                                {
                                    text: 'Unit',
                                    data: 'disclosureOwnerUnits',
                                    sortable: false,
                                    childViewOptions: {
                                        // child tableView options
                                        compact: true,
                                        columns: [
                                            {
                                                childView: UIKit.Header,
                                                childViewOptions: {
                                                    tagName: 'h5',
                                                    attributes: { style: 'font-weight: normal' },
                                                    bindings: {
                                                        text: 'name',
                                                        subText: 'title',
                                                    },
                                                },
                                            },
                                        ],
                                        childViewOptions: {
                                            // child table row options
                                            childViewOptions: {
                                                // child table cell options
                                                attributes: {
                                                    style: 'border-top: 0; padding-left: 0; padding-right: 0;',
                                                },
                                            },
                                        },
                                        emptyText: '',
                                    },
                                },
                                { text: 'Status', data: 'status', sortable: true },
                                { text: 'Resolution', data: 'decisionOutcome', sortable: true },
                                { text: 'Submission Date', data: 'submitDate', sortable: true, formatter: BlocKit.Formatter.date('L LT') },
                                { text: 'Completion Date', data: 'decisionResultDate', sortable: true, formatter: BlocKit.Formatter.date('L LT') },
                                {
                                    text: 'External Organizations',
                                    data: 'disclosureExternalOrgList',
                                    sortable: false,
                                    childViewOptions: {
                                        // child tableView options
                                        compact: true,
                                        columns: [
                                            {
                                                childView: UIKit.Header,
                                                childViewOptions: {
                                                    tagName: 'h5',
                                                    attributes: { style: 'font-weight: normal' },
                                                    bindings: {
                                                        text: 'name',
                                                        visible: 'submitted',
                                                    },
                                                },
                                            },
                                        ],
                                        childViewOptions: {
                                            // child table row options
                                            childViewOptions: {
                                                // child table cell options
                                                attributes: {
                                                    style: 'border-top: 0; padding-left: 0; padding-right: 0;',
                                                },
                                            },
                                        },
                                        emptyText: '',
                                    },
                                },
                                {
                                    width: '4em',
                                    childView: DisclosureListDocumentActionButtons,
                                },

                            ],
                            searchFields: [
                                {
                                    name: 'name',
                                    displayName: 'Disclosure Name',
                                    useDistinctAutocompleteValues: true,
                                },
                                {
                                    name: 'disclosureOwnerFirstName',
                                    displayName: 'First Name',
                                    useDistinctAutocompleteValues: true,
                                },
                                {
                                    name: 'disclosureOwnerLastName',
                                    displayName: 'Last Name',
                                    useDistinctAutocompleteValues: true,
                                },
                                {
                                    name: 'disclosureOwnerUnits',
                                    displayName: 'Unit',
                                    autocompleteCollectionClass: UnitModel.Collection,
                                    autocompleteAttribute: 'name',
                                    useDistinctAutocompleteValues: true,
                                },
                                {
                                    name: 'status',
                                    displayName: 'Status',
                                    useDistinctAutocompleteValues: true,
                                },
                                {
                                    name: 'decisionOutcome',
                                    displayName: 'Resolution',
                                    useDistinctAutocompleteValues: true,
                                },
                            ],
                        },
                    ],
                },
            },
        },
    });

    module.exports = DisclosureAssignedToMeListPageView;
});

